import { MonthlyViewWeek } from "../monthly-view.types";

const createEmptyRow = (week: MonthlyViewWeek) =>
  week.forEach((day, i) =>
    day.slots.push({ type: "EMPTY", key: "empty" + i.toString() }),
  );

const hasCollidingEvents = (
  week: MonthlyViewWeek,
  rowIndex: number,
  startIndex: number,
  lengthInDays: number,
) => {
  for (let i = startIndex; i < startIndex + lengthInDays; i++) {
    if (week[i].slots[rowIndex].type !== "EMPTY") {
      return true;
    }
  }
  return false;
};

const findOrAddRowWithRoomForEvent = (
  week: MonthlyViewWeek,
  startIndex: number,
  lengthInDays: number,
) => {
  const currentRowsCount = week[0].slots.length;

  let firstFreeRowIndex = 0;
  while (
    firstFreeRowIndex < currentRowsCount &&
    hasCollidingEvents(week, firstFreeRowIndex, startIndex, lengthInDays)
  ) {
    firstFreeRowIndex++;
  }

  if (firstFreeRowIndex === currentRowsCount) {
    createEmptyRow(week);
    firstFreeRowIndex = currentRowsCount;
  }

  return firstFreeRowIndex;
};

export default findOrAddRowWithRoomForEvent;
